import { handleActions } from 'redux-actions';

import * as actions from './actions';

const initialState = null;
const options = { prefix: 'Profile' };

const reducer = handleActions(
  {
    RESET_APP: () => initialState,
    [actions.set]: {
      next(state, { payload }) {
        return { ...payload, _lastUpdate: Date.now() };
      },
      throw(state) {
        return state;
      },
    },
    [actions.update]: {
      next(state, { payload }) {
        return { ...state, ...payload, _lastUpdate: Date.now() };
      },
      throw(state) {
        return state;
      },
    },
  },
  initialState,
  options
);

export default reducer;
